import { patientNamespace } from "@/store/modules/patient";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({})
export default class LinksToAnotherArea extends Vue {
  @Prop(Object)
  areaMap!: Record<string, string>;

  navigateToArea(area: string, room: string) {
    this.$router.push({
      name: "body",
      params: {
        room,
        area
      }
    });
  }
}
